import styled from 'styled-components'

export const DateRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
